import { API_BASE } from "../../utils/api";

export async function getVolcanes() {
  const response = await fetch(`${API_BASE}/api/volcanes/`);
  if (!response.ok) {
    throw new Error("Error al obtener volcanes");
  }
  const data = await response.json();
  return Array.isArray(data) ? data : (data?.results ?? []);
}

export async function getVolcanDescripcionById(id) {
  const response = await fetch(`${API_BASE}/api/volcanes/descripcion/${id}/`);
  if (!response.ok) {
    throw new Error("Error al obtener descripción del volcán");
  }
  return response.json();
}

export async function getLineaTiempoPorVolcan(volcanId) {
  const response = await fetch(
    `${API_BASE}/api/volcanes/linea-tiempo/${volcanId}/`,
  );
  if (!response.ok) {
    throw new Error("Error al obtener línea de tiempo");
  }
  return response.json();
}

export async function getDocumentosPorVolcan(volcanId) {
  const response = await fetch(
    `${API_BASE}/api/volcanes/documentos/${volcanId}/`,
  );
  if (!response.ok) {
    throw new Error("Error al obtener documentos");
  }
  return response.json();
}

export async function getCartografiaHistoricaPorVolcan(volcanId) {
  const response = await fetch(
    `${API_BASE}/api/volcanes/cartografia-historica/${volcanId}/`,
  );
  if (!response.ok) {
    throw new Error("Error al obtener cartografía histórica");
  }
  return response.json();
}

export async function getMapasAmenazaPorVolcan(volcanId) {
  const response = await fetch(
    `${API_BASE}/api/volcanes/mapas-amenaza/${volcanId}/`,
  );
  if (!response.ok) {
    throw new Error("Error al obtener mapas de amenaza");
  }
  return response.json();
}

export async function getEventoDetalleAmpliado(volcanId, eventoId) {
  const response = await fetch(
    `${API_BASE}/api/volcanes/linea-tiempo/${volcanId}/evento/${eventoId}/`,
  );
  if (!response.ok) {
    throw new Error("Error al obtener la información del evento");
  }
  return response.json();
}
